import React from 'react';
import { Typography } from '@mui/material';
import RemoveIcon from '@mui/icons-material/RemoveOutlined';
import { Button, ButtonProps } from '../../mui-builder/Button/Button';
import ButtonWithConfirmation from './ButtonWithConfirmation';
import { useUiTheme } from 'framework/uiTheme';

const DEFAULT_PERMISSION_TO_CHECK = 'DELETE';

export interface DeleteButtonProps extends ButtonProps {
  deleteMethod: () => Promise<void>;
  displayMessage: string;
  permissionToCheck?: Nullable<string | string[]>;
  afterDelete?: {
    successMessage?: string;
    errorMessage?: string;
    redirectUrl?: string;
    errorStatusesMessages?: Dictionary<string>;
    execute?: (data?: any) => void;
    executeOnError?: () => void;
  };
  showIcon?: boolean;
  buttonText?: React.ReactNode;
  className?: string;
  outline?: boolean;
  color?: BasicColors;
  modalChildren?: React.ReactElement | React.ReactElement[];
  modalConfirmButtonText?: React.ReactNode;
  confirmBtnProps?: ButtonProps;
}

const DeleteButton = ({
  deleteMethod,
  permissionToCheck = DEFAULT_PERMISSION_TO_CHECK,
  afterDelete,
  showIcon = false,
  buttonText = 'Delete',
  buttonTag,
  outline = true,
  color = 'primary',
  modalConfirmButtonText,
  ...props
}: DeleteButtonProps) => {
  const { Button: ThemedButton = Button } = useUiTheme();
  const ButtonTag = buttonTag ?? ThemedButton;

  return (
    <ButtonWithConfirmation
      {...props}
      variant="outlined"
      color={color}
      buttonTag={ButtonTag}
      afterSubmit={afterDelete}
      submitMethod={deleteMethod}
      permissionToCheck={permissionToCheck}
      modalConfirmButtonText={modalConfirmButtonText || buttonText}
      startIcon={showIcon ? <RemoveIcon fontSize="small" /> : null}
    >
      {typeof buttonText === 'string' ? <Typography variant="subtitle1">{buttonText}</Typography> : buttonText}
    </ButtonWithConfirmation>
  );
};

export default DeleteButton;
